export const SidebarAccordionActionsTypes = {
  SET_CURRENT_SCROLL: '[Sidebar Accordion] Set current scroll'
} as const;

export const SetCurrentScroll = (currentScroll: number) => {
  return {
    type: SidebarAccordionActionsTypes.SET_CURRENT_SCROLL,
    payload: currentScroll
  };
};
